import axios, { AxiosPromise } from 'axios'
import { RastreioCancerInput } from 'graphql/types.generated'
import {
  ImpressaoRequisicaoRastreioCancerBaseInput,
  ImpressaoRequisicaoRastreioCancerInput,
  ImpressaoSolicitacaoExamesInput,
} from 'view/atendimentos/detail/soap/plano/exames/model-solicitacaoExames'

interface ImpressaoSolicitacaoExameInputModel {
  solicitacoes: ImpressaoSolicitacaoExamesInput[]
  citopatologicoPreenchido: RastreioCancerInput[]
  mamografiaPreenchido: RastreioCancerInput[]
}

export class ImpressaoSolicitacaoExames {
  imprimirSolicitacaoExames(input: ImpressaoSolicitacaoExameInputModel): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames', input, { responseType: 'blob' })
  }

  imprimirRequisicaoMamografia(input: ImpressaoRequisicaoRastreioCancerBaseInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoMamografia', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoCitopatologico(input: ImpressaoRequisicaoRastreioCancerBaseInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoCitopatologico', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoCitopatologicoComDados(input: ImpressaoRequisicaoRastreioCancerInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoCitopatologicoComDados', input, {
      responseType: 'blob',
    })
  }

  imprimirRequisicaoMamografiaComDados(input: ImpressaoRequisicaoRastreioCancerInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirSolicitacaoExames/imprimirRequisicaoMamografiaComDados', input, {
      responseType: 'blob',
    })
  }
}
